/**
 * Session 25 — OCPP 2.0.1 Security outbound (CP → CSMS):
 *   - SignCertificate          — CP submits a CSR for the CSMS to sign.
 *   - SecurityEventNotification — CP reports a security event.
 * v2.0.1-only.
 */
export interface SignCertificateDomain {
  readonly csr: string;
  readonly certificateType?: string;
}

export function buildSignCertificateRequest(req: SignCertificateDomain): Record<string, unknown> {
  return {
    csr: req.csr,
    ...(req.certificateType !== undefined ? { certificateType: req.certificateType } : {}),
  };
}

export interface SecurityEventNotificationDomain {
  readonly type: string;
  readonly timestamp: string;
  readonly techInfo?: string;
}

export function buildSecurityEventNotificationRequest(
  req: SecurityEventNotificationDomain,
): Record<string, unknown> {
  return {
    type: req.type,
    timestamp: req.timestamp,
    ...(req.techInfo !== undefined ? { techInfo: req.techInfo } : {}),
  };
}
